import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const dateFilter = (): FilterDefinition => ({
  label: i18n.t('banking.payments.data_table.date'),
  type: 'date',
  options: {
    mode: 'range',
  },
})
